import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import * as hookActions from 'checkout/actions/hooks';
import { bindActionCreators } from 'redux';
import { convertToISOWithTimezone } from 'helpers/time';
import { toDecimals } from '../../helpers/currency';
import { getOrderTotal } from '../../selectors/cart';

export class Hive extends Component {
    constructor(props) {
        super(props);
        const hooks = [
            'addTicketsAddedToCartHook',
            'addTicketsRemovedFromCartHook',
            'addTicketIncrementHook',
            'addTicketDecrementHook',
            'addProductsAddedToCartHook',
            'addProductsRemovedFromCartHook',
            'addProductIncrementHook',
            'addProductDecrementHook',
            'addBundlesAddedToCartHook',
            'addBundlesRemovedFromCartHook',
            'addBundleIncrementHook',
            'addBundleDecrementHook',
            'addInsuranceOptionChangedHook',
            'addGoToCheckoutHook',
            'addReservationCompleteHook',
        ];
        hooks.forEach(hookName => {
          const isCompleted = hookName === 'addReservationCompleteHook';
          if (typeof this.props[hookName] === 'function') {
            this.props[hookName](() => this.sendToHive(isCompleted));
          }
        });


        (function(h, i, v, e, s, d, k) {
            h.HiveSDKObject = s;
            h[s] = h[s] || function() {
                (h[s].q = h[s].q || []).push(arguments)
            },
            d = i.createElement(v),
            k = i.getElementsByTagName(v)[0];
            d.async = 1;
            d.id = s;
            d.src = e + '?r=' + parseInt(new Date() / 60000);
            k.parentNode.insertBefore(d, k)
        })(window, document, 'script', 'https://cdn-prod.hive.co/static/js/sdk-loader.js', 'HIVE_SDK');

        HIVE_SDK('init', props.config.id);
    }

    render() {
        return null;
    }

    getOrderData = (hiveAction,isCompleted) => {
      const reservation = this.props.reservation;
      if (!reservation || !reservation.reservation_id) {
        return null;
      }
      const data = {
        id: reservation.reservation_id,
        status: isCompleted ? 'completed' : 'started',
        total_paid: toDecimals(this.props.orderTotal),
      };

      if (hiveAction === 'update') {
        return data;
      }
      const firstVenue = Object.values(this.props.venue?.venues || {})[0];

      const firstEventEntry = Object.values(this.props.event.events || {})[0];
      const firstEvent = firstEventEntry?.event;
      const strippedDescription = firstEvent.description?.replace(/<[^>]*>?/gm, '') || '';
      const shortDescription = strippedDescription.slice(0, 150);
      const start_time = convertToISOWithTimezone(firstEvent.start,firstVenue.address.timezone);
      const end_time = firstEvent.end ? convertToISOWithTimezone(firstEvent.end,firstVenue.address.timezone) : start_time


      return {
        ...data,
        event: {
          id: firstEvent.event_id,
          name: firstEvent.name,
          description: shortDescription,
          start_time: start_time,
          end_time: end_time,
          url: this.props.eventUrl,
        },
        venue: {
          name: firstVenue.name,
          city: firstVenue.address.city,
          state: firstVenue.address.region,
          country: firstVenue.address.country,
        },
      };
    };

    memberSignup = () => {
      const memberEmail = this.props.member?.email || '';
      if (memberEmail){
        HIVE_SDK(
            "emailSignup",
            {
                email: memberEmail,
            },
            function (data) {
                console.log('emailSignup successfully', data);
            },
            function (data) {
                console.log('emailSignup failed', data);
            }
        );
      }
    }

    sendToHive = (isCompleted) => {
      this.memberSignup();

      const hiveOrderCacheKey = `hive_order_${this.props.reservation.reservation_id}`;
      const hiveAction = sessionStorage.getItem(hiveOrderCacheKey) ? 'update'  : 'create';
      const orderData = this.getOrderData(hiveAction,isCompleted);
      if (!orderData) {
        return null;
      }
      sessionStorage.setItem(hiveOrderCacheKey, '1');

      HIVE_SDK(
          "ticketingOrder",
          hiveAction,
          orderData,
          function() {
              console.log("Hive ticketingOrder " + hiveAction + " successfully.");
          },
          function(error) {
              console.error("Hive ticketingOrder failed:", error);
          }
      );
    };
}

Hive.propTypes = {
    config: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
    return {
        reservation: state.reservation,
        member: state.member,
        event: state.event,
        eventUrl: state.ui.uiConfig.partnerUrl+'/tickets/'+state.ui.listingSlug,
        venue: state.venue,
        orderTotal: getOrderTotal(state),
    }
}

const mapDispatchToProps = dispatch => {
    const actions = {};
    Object.keys(hookActions).forEach(hookActionName => {
        actions[hookActionName] = hookActions[hookActionName];
    });
    return bindActionCreators(actions, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(Hive)

